<template>
  <div class="publication-card">
    <div
      class="publication-card-image"
      :style="{backgroundImage: `url(${info.image})`}"
    />

    <div class="publication-card-info">
      <div class="title">
        {{ info.title }}
      </div>
      <div
        class="description"
        v-html="info.announcement"
      />
      <div class="date">
        {{ info.publishedOn | date({showYear: true}) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publication-card',

  props: {
    info: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss">
.publication-card {
  margin-top: 16px;
  border: 1px solid $gray_lu2;
  overflow: hidden;

  &-image {
    display: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  &-info {
    display: flex;
    flex-direction: column;
    min-height: 164px;
    padding: 16px;

    & > .title,
    & > .description,
    & > .date {
      line-height: 20px;
    }

    & > .title,
    & > .description p {
      /* stylelint-disable-next-line */
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    & > .description p,
    & > .date {
      font-size: 12px;
    }

    & > .title {
      font-size: 16px;
      font-weight: 600;
    }

    & > .description p {
      margin-top: 8px;
      min-height: 40px;
    }

    & > .date {
      color: $gray;
      margin-top: auto;
      padding-top: 8px;
      border-top: 1px solid $gray_lu2;
    }
  }
}

@include breakpoint("tablet") {
  .publication-card {
    width: 224px;
    margin-top: 32px;

    &-image {
      display: block;
      width: 100%;
      height: 146px;
      background-color: $blue;
    }

    &-info {
      height: calc(100% - 146px);
    }
  }
}

@include breakpoint("desktop") {
  .publication-card {
    width: 392px;
    height: 508px;
    cursor: pointer;

    &-image {
      height: 254px;
    }

    &-info {
      height: calc(100% - 254px);
      padding: 24px;

      & > .title {
        font-size: 20px;
        line-height: 28px;
      }

      & > .description p,
      & > .date {
        font-size: 16px;
        line-height: 24px;
      }

      & > .description p {
        -webkit-line-clamp: 3;
      }

      & > .date {
        padding-top: 16px;
      }
    }
  }
}
</style>